import { SelectionGenericService } from './../../../../selection-generic/services/selection-generic.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';
import { SaveLeaveReportNameComponent } from 'app/modules/reports/components/leave-report-view/leave-report-panels/save-leave-report-name/save-leave-report-name.component';
import { LeaveReport, LeaveReportTemplateList } from 'app/modules/reports/entities/Leave-report-model';
import { ReportsCommonService } from 'app/modules/reports/services/reports-common.service';
import { ReportsLeaveReportService } from 'app/modules/reports/services/reports-leave-report.service';
import { FileExportService } from 'app/modules/selection-generic/services/file-export.service';
import * as _ from 'lodash';
import { ConfirmDialogModel } from '../../confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
import Utils from 'app/Utils';

@Component({
    selector: 'app-template-selector',
    templateUrl: './template-selector.component.html',
    styleUrls: ['./template-selector.component.scss'],
    standalone: false
})
export class TemplateSelectorComponent implements OnInit {

    private selectedReport: LeaveReport;
    private newReport = {};
    private currentUser: any;
    private checkBoxField = ['bajasAnteriores', 'listadoBajasAnt', 'diasBajasAnt', 'acumBajasAnt', 'diagnosticoBajasAnt',
        'actuaciones', 'ultimaVisita', 'medicoVisita', 'textoActuacion', 'ultimaGestion', 'diferenciarVisitaContacto', 'solicitudes', 'comentarioParaEmpresa', 'comentariosInternos', 'comentariosExternos', 'ultimoComentario',
        'bajaActual', 'excluirNoVisitar', 'tipoBaja', 'avisoBaja', 'inspeccion', 'noJustificada', 'diagnosticoBaja', 'actitudNegativa', 'obsBaja',
        'diasBaja', 'fpa', 'diasPrevistos', 'graficoDiasBaja', 'diasAcum', 'diasAcum180', 'graficoDiasAcum',
        'empresa', 'absentista', 'puestoUrgente', 'poblacion', 'edad',
        'tareas', 'tareasTebex', 'autorTarea',
        'costeAbsentismo', 'costeIndemnizacion',
    ];
    public reportFormGroup: UntypedFormGroup;
    public reportDropDownList: LeaveReportTemplateList;
    public permissionList = [];
    public selectedTemplateId: any;
    public isListLoading = false;
    empresaId: number;

    constructor(
        private _sharedService: SharedService,
        private dialog: MatDialog,
        public _reportsLeaveReportService: ReportsLeaveReportService,
        public empresaTreeViewService: EmpresaTreeViewService,
        public _reportsCommonService: ReportsCommonService,
        public fb: UntypedFormBuilder,
        private _selectionService: SelectionGenericService,
    ) {
        this.selectedReport = new LeaveReport();
        this.empresaTreeViewService.EmpId.subscribe((_res: any) => {
            if (_res > 0) {
                this.empresaId = _res;
                // this._reportsCommonService.empresaId = this.empresaId;
            }
        });

    }

    ngOnInit(): void {
        this.getPermissionList();
        this.createReportForm();
        this.LoadDefaultTemplate();

        this.empresaId = JSON.parse(localStorage.getItem('Empresa'));
        // this._reportsCommonService.empresaId = this.empresaId;

        this.reportFormGroup.valueChanges.subscribe(res=>{
            var convertedReport = this.convertCheckBoxValuesToString(this.newReport);
            this._selectionService.leaveSelectionModal=convertedReport;
            localStorage.setItem('leave-report-pharms',JSON.stringify(convertedReport))
        })
    }

    private getPermissionList() {
        this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) 
        if (this.currentUser) {
            this.permissionList = this.currentUser.permissionIds;
        }
    }

    private createReportForm() {
        this.reportFormGroup = this.fb.group({

            InformeId: [''],
            Nombre: [''],

            Titulo: [''],

            Idioma: [''],
            Orden: [''],
            Formato: [''],
            SaltoPagina: [''],

            BajasAnteriores: [''],
            ListadoBajasAnt: [''],
            DiasBajasAnt: [''],
            AcumBajasAnt: [''],
            DiagnosticoBajasAnt: [''],

            GraficoBajasAnt: [''],
            AnyosBajasAnt: [''],

            Actuaciones: [''],
            UltimaVisita: [''],
            MedicoVisita: [''],
            TextoActuacion: [''],
            UltimaGestion: [''],
            diferenciarVisitaContacto: [''],
            Solicitudes: [''],
            ComentarioParaEmpresa: [''],
            ComentariosInternos: [''],
            ComentariosExternos: [''],
            UltimoComentario: [''],

            BajaActual: [''],
            ExcluirNoVisitar: [''],
            TipoBaja: [''],
            AvisoBaja: [''],
            Inspeccion: [''],
            NoJustificada: [''],
            DiagnosticoBaja: [''],
            ActitudNegativa: [''],
            ObsBaja: [''],

            DiasBaja: [''],
            FPA: [''],
            DiasPrevistos: [''],
            GraficoDiasBaja: [''],
            DiasAcum: [''],
            DiasAcum180: [''],
            GraficoDiasAcum: [''],

            Empresa: [''],
            Absentista: [''],
            PuestoUrgente: [''],
            Poblacion: [''],
            Edad: [''],

            Tareas: [''],
            TareasTebex: [''],
            AutorTarea: [''],

            CosteAbsentismo: [''],
            CosteIndemnizacion: ['']

        });
    }

    public addOrEditReport(selectedTemplateId: number) {

        var convertedReport = this.convertCheckBoxValuesToString(this.newReport);

        const dialogRef = this.dialog.open(SaveLeaveReportNameComponent, {
            data: { reportData: convertedReport, selectedReport: selectedTemplateId },
            width: '400px'
        });

        dialogRef.afterClosed().subscribe(addedOrEditedId => {
            if (addedOrEditedId != null) {
                this.GetAllTemplateNames();
                this.selectedTemplateId = addedOrEditedId;
                this._reportsCommonService.templateId = this.selectedTemplateId;
            }
        });

    }

    public deleteReport(selectedTemplateId: number) {
        if (selectedTemplateId != 1) {
            const dialogData = new ConfirmDialogModel('¿Eliminar el tipo de informe seleccionado?', "");
            const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                data: dialogData
            });

            dialogRef.afterClosed().subscribe(responce => {
                if (responce) {
                    this._reportsLeaveReportService.deleteTemplate(selectedTemplateId)
                        .subscribe(res => {
                            if (res.code === 0) {
                                this._sharedService.ShowSnackBar('Borrado exitosamente');
                                this.LoadDefaultTemplate();
                            } else {
                                this._sharedService.ShowSnackBar('Eliminar fallar');
                            }
                        }, err => {
                            this._sharedService.ShowSnackBar('Eliminar fallar');
                            console.error(err);
                        });
                }
            });

        } else {
            //if selected value is the default template
            this._sharedService.ShowSnackBar('Cannot delete the default template');
        }
    }


    private LoadDefaultTemplate() {
        //select default template in the dropdown
        this.selectedTemplateId = 1;
        this._reportsCommonService.templateId = this.selectedTemplateId;

        //get default template data  
        this.GetReportTemplateListById(this.selectedTemplateId);
        this.GetAllTemplateNames();
    }

    private GetReportTemplateListById(id: number): void {
        this.isListLoading = true;
        this._reportsLeaveReportService.getReportTemplateListById(id).subscribe(res => {
            if (res.code === 0) {
                this.selectedReport = res.result;
                //set default template data to form fields
                this.SetValuesToFormFields();
                this.isListLoading = false;
            } else {
                this.isListLoading = false;
                this._sharedService.ShowSnackBar('falló');
            }
        }, () => {
            this.isListLoading = false;
            this._sharedService.ShowSnackBar('falló');
        });
    }

    private GetAllTemplateNames(): void {
        this.isListLoading = true;
        this._reportsLeaveReportService.getAllTemplateNames().subscribe(res => {
            if (res.code === 0) {
                this.reportDropDownList = res.result;
                this.isListLoading = false;
            } else {
                this.isListLoading = false;
                this._sharedService.ShowSnackBar('falló');
            }
        }, () => {
            this.isListLoading = false;
            this._sharedService.ShowSnackBar('falló');
        });
    }


    private convertCheckBoxValuesToString(newReport): any {
        for (const field in this.reportFormGroup.controls) {
            const control = this.reportFormGroup.get(field);
            let fieldtemp = this.getObjectName(field);
            if (this.checkBoxField.includes(fieldtemp)) {
                newReport[fieldtemp] = (control.value === true) ? "S" : "N";
            } else if ("graficoBajasAnt" == fieldtemp) {
                newReport[fieldtemp] = (control.value === true) ? 1 : 0;
            }
            else {
                newReport[fieldtemp] = control.value;
            }
        }
        return newReport;
    }

    private SetValuesToFormFields() {
        for (const field in this.reportFormGroup.controls) {
            const control = this.reportFormGroup.get(field);
            let fieldtemp = this.getObjectName(field);
            let value = this.selectedReport[fieldtemp];
            if (this.checkBoxField.includes(fieldtemp)) {
                value = this.selectedReport[fieldtemp] == 'S';
                control.setValue(value);
            } else if ("graficoBajasAnt" == fieldtemp) {
                value = (this.selectedReport[fieldtemp] == 1) ? true : false;
                control.setValue(value);
            } else {
                control.setValue(value);
            }
        }
    }

    public onChangeCompany(event: any) {
        this.selectedTemplateId = event.value;
        this._reportsCommonService.templateId = this.selectedTemplateId;

        this.GetReportTemplateListById(this.selectedTemplateId);
    }

    private getObjectName(fieldName: string) {
        return _.camelCase(fieldName);
    }

}
